import StreamSettings from 'redhotpie-shared-lib/models/streamSetting';
import * as types from '../constants/actionTypes';
import { SRC_TYPES, TSrcType } from '../constants/config';
import * as constants from '../constants/constants';
import * as messageUtils from '../functions/messageUtils';
import * as storageHelper from '../functions/storageHelper';
import { formatSpaceNumber, getUnavailablePopupData } from '../functions/utils';
import WebIM from '../libs/webIM';
import { default as config, default as WebIMConfig } from '../libs/webIMConfig';
import AccountSettingsProfile from '../models/accountSettingsProfile';
import EmailNotificationSettings from '../models/emailNotificationSettings';
import ImageDuration from '../models/imageDuration';
import LinkedAccounts from '../models/linkedAccounts';
import MemberProfile from '../models/memberProfile';
import MessengerTheme from '../models/messengerTheme';
import PushNotificationSettings from '../models/pushNotificationSettings';
import ToolTipSetting from '../models/toolTipSetting';
import accountSettingService from '../services/accountSettingService';
import authService from '../services/authService';
import memberSearchService from '../services/memberSearchService';
import notificationSettingsService from '../services/notificationSettingsService';
import userService from '../services/userService';
import * as myStore from '../store/myStore';
import * as accountSettingActions from './accountSettingActions';
import * as commonStateActions from './commonStateAction';
import { getServerTime, updateCommonStateReducerSuccess } from './commonStateAction';
import * as connectAction from './connectAction';
import * as conversationInboxAction from './conversationInboxAction';
import * as foldersActions from './foldersActions';
import * as iceBreakerAction from './iceBreakerAction';
import * as quickMessageAction from './quickMessageAction';
import * as rosterActions from './rosterActions';
import { getUsersBlocked, getUserWhoBlockMeList } from './userActions';
import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';
import { IUserInfo } from 'redhotpie-shared-lib/types/login';
import { IPayloadLogin, IPayloadRegister } from '../reducers/loginReducer';
import MemberSearch from 'redhotpie-shared-lib/models/memberSearch';
import { ILoginState } from '../types/login';
import { bool } from 'prop-types';
import Photo from 'redhotpie-shared-lib/models/photo';
import { IParamSignInWithFacebook } from '../services/authService';
import { IActivityFilterItem } from 'redhotpie-shared-lib/interfaces/IStream';
import { IMainPhoto } from 'redhotpie-shared-lib/interfaces/IUser';

const _utils = require('../sdks/src/utils').utils;

const configApp = require('../../app');

const isNative = !configApp || !configApp.isWebApp;

export function loginSuccess() {
  return { type: types.USER_LOGIN_SUCCESS };
}

export function logoutSuccess() {
  return { type: types.USER_LOGOUT_SUCCESS };
}

export function loginFail(error: any, msg: string) {
  return { type: types.USER_LOGIN_FAIL, error, msg };
}

export function requestChatLogin(login: IPayloadLogin) {
  return { type: types.USER_REQUEST_LOGIN, login };
}

export function requestLoginUserInfoSuccess(login: Pick<IPayloadLogin, 'userInfo'>) {
  return { type: types.USER_REQUEST_USER_LOGIN_INFO_SUCCESS, login };
}

export function updateFromUserJid(data: string) {
  return { type: types.USER_UPDATE_JID, data };
}

export function updateUserInfo(userInfo: Partial<IUserInfo>) {
  return { type: types.USER_UPDATE_INFO_SUCCESS, userInfo };
}

export function registerSuccess() {
  return { type: types.USER_REGISTER_SUCCESS };
}

export function registerFail(error: any) {
  return { type: types.USER_REGISTER_FAIL, error };
}

export function requestRegister(register: IPayloadRegister) {
  return { type: types.USER_REQUEST_REGISTER, register };
}

export function updateErrorStatus(data: any) {
  return { type: types.UPDATE_ERROR_STATUS_LOGIN, data };
}

export function connectFacebookSuccess(data: any) {
  return { type: types.CONNECT_FACEBOOK_SUCCESS, data };
}

export function updateStatusLoginFbSuccess(data: boolean) {
  return { type: types.UPDATE_STATUS_LOGIN_FB, data };
}

export function requestForgotPasswordSuccess(data: boolean) {
  return { type: types.REQUEST_FORGOT_PASSWORD_SUCCESS, data };
}

export function firstCallApi() {
  return { type: types.FIRST_CALL_API };
}

export function getJIdResourceSuccess(data: string) {
  return { type: types.GET_JIDRESOURCE_SUCCESS, data };
}

export function updateRetainStatusSuccess(data: any) {
  return { type: types.UPDATE_RETAIN_STATUS_SUCCESS, data };
}

export function updateLoginState(data: { key: string[]; value: any }) {
  return { type: types.UPDATE_LOGIN_STATE, data };
}

export function getUserSearchSettingsSuccess(data: MemberSearch) {
  return { type: types.GET_USER_SEARCH_SETTINGS_SUCCESS, data };
}

export function updateLoginReducerState(data: Partial<ILoginState>) {
  return { type: types.UPDATE_LOGIN_REDUCER_STATE, data };
}

export function updateStateUserLogin(dataKey: string[], data: any) {
  return { type: types.UPDATE_STATE_USER_LOGIN, dataKey, data };
}

export function processLogin(
  dispatch: any,
  userName: string,
  sessionJIdResourceMobile?: string,
  buildVersion?: string,
  shouldUseLocalData?: boolean
) {
  handleXmppLogin(dispatch, userName, sessionJIdResourceMobile);

  // dispatch(loadGiftsReceived());

  if (shouldUseLocalData) {
    dispatch(getUserSearchSettings());
    getUserSetting(dispatch);
    dispatch(updateLoginReducerState({ isLogin: true }));
    dispatch(updateProfile());
    const { loginReducer } = myStore.getStore().getState();
    if (loginReducer && loginReducer.isLogin) {
      return Promise.resolve(loginReducer);
    }
    return Promise.resolve(loginReducer);
  } else {
    dispatch(updateLoginReducerState({ isLogin: true }));
    return getMemberTypeInfo(dispatch, buildVersion);
  }
}

const handleXmppLogin = async (dispatch: any, userName: string, sessionJIdResourceMobile?: string) => {
  try {
    const res = await userService.getUserXmppDetail();
    if (res && res.success) {
      const xmppUserName = res.data.UserID.toString();
      const xmppPassword = res.data.XMPPPassword.toString();
      let sessionJIdResource = '';
      let jIdResource = '';

      if (isNative) {
        jIdResource = sessionJIdResourceMobile ? xmppUserName.trim().toLowerCase() + sessionJIdResourceMobile : '';
        if (sessionJIdResourceMobile) {
          dispatch(getJIdResourceSuccess(sessionJIdResourceMobile));
        }
      }

      if (!jIdResource) {
        if (WebIM.config.isMultiLoginSessions) {
          sessionJIdResource = _utils.generateJidResource();
        }
        jIdResource = xmppUserName.trim().toLowerCase() + sessionJIdResource;
        if (!isNative && storageHelper.storageCachingSupported()) {
          storageHelper.setKey(constants.SESSIONS.JID_RESOURCE, sessionJIdResource);
          dispatch(updateFromUserJid(sessionJIdResource));
        } else {
          dispatch(getJIdResourceSuccess(sessionJIdResource.toString()));
        }
      }

      const login: Partial<ILoginState> = {
        userName: xmppUserName,
        password: xmppPassword,
        rhpUserName: userName,
        rhpPassword: '',
        xmppId: res.data.XMPPID,
        jIdResource,
        // userInfo: {},
      };

      dispatch(
        requestChatLogin({
          userName: login.userName || '',
          password: login.password || '',
          rhpUserName: login.rhpUserName || '',
          rhpPassword: login.rhpPassword || '',
        })
      );

      if (!WebIM.conn.isClosed() && !WebIM.conn.isClosing()) {
        WebIM.conn.close('logout');
      }

      const xmppAuthLogin = {
        xmppId: messageUtils.addPrefixAndSuffix(login.userName!) || '',
        password: login.password!.startsWith('$t$') ? login.password! : `$t$${login.password!}`,
      };

      dispatch(updateLoginReducerState({ gettingUserXmppDetail: true }));

      try {
        const authRes = await authService.login(xmppAuthLogin);
        dispatch(updateLoginReducerState({ gettingUserXmppDetail: false }));

        if (authRes && authRes.success) {
          dispatch(getServerTime());

          // login.userInfo = {
          //   xmppId: authRes.data.user.xmppId,
          //   online: authRes.data.user.online,
          // };
          const { isOpenWS } = myStore.getStore().getState().loginReducer;

          if (isOpenWS) {
            connectAction.tryConnectNow(true, {
              apiUrl: WebIM.config.apiURL,
              user: login.userName!.trim().toLowerCase(),
              pwd: login.password!,
              accessToken: login.password!,
              appKey: WebIM.config.appkey,
              resource: login.jIdResource!,
            });
          }
          dispatch(updateLoginReducerState({ isLoginXmpp: true }));
          dispatch(
            requestLoginUserInfoSuccess({
              userInfo: {
                xmppId: authRes.data.user.xmppId,
                online: authRes.data.user.online,
              },
            })
          );
        } else {
          dispatch(updateLoginReducerState({ isLoginXmpp: false }));
        }
        processCallFirstActions(dispatch);
      } catch (e) {
        console.log('ERROR : loginAction/login/authService.login', e);
        processCallFirstActions(dispatch);
        dispatch(
          updateLoginReducerState({
            isLoginXmpp: false,
            gettingUserXmppDetail: false,
          })
        );
      }
    } else {
      console.log('Login RHP server failed');
      dispatch(updateLoginReducerState({ isLoginXmpp: false }));
    }
  } catch (e) {
    console.log('ERROR : Login RHP server failed, loginAction/login/userService.getUserXmppDetail', e);
    dispatch(updateLoginReducerState({ isLoginXmpp: false }));
  }
};

// function connectXMPP(dispatch, userName, sessionJIdResourceMobile) {
//
// }

function getUserSetting(dispatch: any) {
  let userInfo: Partial<IUserInfo> = {};
  dispatch(requestLoginUserInfoSuccess({ userInfo: { isLoadingUserSettings: true } }));
  return userService.getUserSettings().then((res: IApiResponse) => {
    if (res && res.success) {
      userInfo = mappingUserSetting(res.data);
    } else {
      if (`${res?.statusCode}` === '1001') {
        WebIMConfig.logOut?.();
      }
    }

    dispatch(
      requestLoginUserInfoSuccess({
        userInfo: { ...userInfo, isOnlineUpdateTime: userInfo.isOnlineUpdateTime, isLoadingUserSettings: false },
      })
    );
    if (userInfo.accountStatus === constants.ACCOUNT_STATUS.AUTHENTICATION_REQUIRE) {
      // Handle checking ScammerSuspected to show Authentication modal
      dispatch(
        commonStateActions.updateCommonStateReducerSuccess({
          isShowAuthenticationModal: true,
          isScammerMode: true,
        })
      );
    }
    // Dispatch state unavailable to commonStateReducer to avoid issue save cache by persist
    dispatch(updateCommonStateReducerSuccess(getUnavailablePopupData(res.data)));
    return userInfo;
    // !isFailed && dispatch(loginSuccess());
    //  dispatch(loginSuccess());
  });
}

export function getUserSettings() {
  return (dispatch: any) => {
    return userService.getUserSettings().then(res => {
      let userInfo: Partial<IUserInfo> = {};
      if (res.success) {
        userInfo = mappingUserSetting(res.data);
      } else {
        if (`${res?.statusCode}` === '1001') {
          WebIMConfig.logOut?.();
        }
      }
      dispatch(requestLoginUserInfoSuccess({ userInfo }));
      // Dispatch state unavailable to commonStateReducer to avoid issue save cache by persist
      dispatch(updateCommonStateReducerSuccess(getUnavailablePopupData(res.data)));
      if (userInfo.accountStatus === constants.ACCOUNT_STATUS.AUTHENTICATION_REQUIRE) {
        // Handle checking ScammerSuspected to show Authentication modal
        dispatch(
          commonStateActions.updateCommonStateReducerSuccess({
            isShowAuthenticationModal: true,
            isScammerMode: true,
          })
        );
      }
      return userInfo;
    });
  };
}

export function getUserAdditionData(dispatch: any) {
  let userInfo: Partial<IUserInfo> = {};
  userService.getUserMainPhoto().then(res => {
    // /  console.log('user main photo', res)
    if (res.data) {
      userInfo = mappingUserAvatar(res.data);
      // console.log(userInfo)
    }
    dispatch(requestLoginUserInfoSuccess({ userInfo }));
  });
}

function getMemberTypeInfo(dispatch: any, buildVersion?: string) {
  // / GET MEMBER TYPE FROM RHP Server
  let userInfo: Partial<IUserInfo> = {};
  dispatch(getUserSearchSettings());
  dispatch(accountSettingActions.getUserPhone());
  return userService
    .getUserProfileSummary(buildVersion)
    .then(resUser => {
      if (resUser.success) {
        userInfo = mappingUserInfo(resUser.data);
        if (!isNative && userInfo.displayName) {
          // update lasted logged username
          storageHelper.setKey(constants.SESSIONS.LASTED_LOGGED_USER_NAME, userInfo.displayName?.toLowerCase());
        }

        getUserAdditionData(dispatch);
        return getUserSetting(dispatch).then(() => {
          dispatch(requestLoginUserInfoSuccess({ userInfo }));
          dispatch(loginSuccess());
          return resUser;
        });
      }
      return resUser;
    })
    .catch(e => {
      console.log('ERROR : loginAction/login/userService.getProfileSummary', e);
      return false;
    });
}

export function getUserSearchSettings() {
  return (dispatch: any) => {
    return memberSearchService.getUserSearchSettings().then(res => {
      if (res.success) {
        dispatch(getUserSearchSettingsSuccess(res.data!));
        return res;
      }
      console.warn('ERROR: memberSearchActions/getUserSearchSettings', res.message);
      return { success: false, data: {}, message: res.message };
    });
  };
}

function isLoadingGetConversations() {
  return myStore.getStore().getState().conversationsReducer.isConversationsLoading;
}

function processCallFirstActions(dispatch: any) {
  // // get contacts
  dispatch(rosterActions.getContacts());
  // // get blacklist
  // getStore().dispatch(blacklistActions.getBlacklist());
  // // get group list
  // dispatch(groupActions.getGroups(true));
  // //  dispatch(groupActions.getRoomMembers(room));
  // let room = { roomJid: 'rhp#testing_rhp#testing_groupchat_secure5@muc.chatxmpp.redhotpie.com.au'};
  // getStore().dispatch(groupActions.destroyChatRoom(room));
  dispatch(firstCallApi());
  // Get list of conversation
  if (!isLoadingGetConversations()) {
    dispatch(conversationInboxAction.getConversations());
  }
  // Get list of friend and favorites
  // dispatch(userActions.getExistItemForAllFilterOption()); // Only call this action in messenger inbox screen
  // Get list iceBreaker
  dispatch(iceBreakerAction.loadIceBreakers());
  // Get list quick message
  dispatch(quickMessageAction.loadQuickMessages());
  // Get list folder message
  dispatch(foldersActions.getFolders());

  // Handle get users blocked when process login to avoid issue create blocked conversation
  dispatch(getUsersBlocked());
  dispatch(getUserWhoBlockMeList());
}

export function updateProfile(buildVersion?: string, notCallSetting: boolean = false) {
  let userInfo = {};
  return (dispatch: any) => {
    return userService.getUserProfileSummary(buildVersion).then(resUser => {
      if (resUser.success) {
        userInfo = mappingUserInfo(resUser.data);
        getUserAdditionData(dispatch);
        if (!notCallSetting) {
          getUserSetting(dispatch);
        }
        dispatch(requestLoginUserInfoSuccess({ userInfo }));
        return userInfo;
      }
      return userInfo;
    });
  };
}

export function login(
  userName: string,
  password?: string,
  sessionJIdResourceMobile?: string,
  rememberMe: any = {},
  buildVersion?: string,
  agent?: any,
  identifier?: string,
  shouldUseLocalData?: boolean,
  reCAPTCHAToken?: string,
  setRememberMe?: any,
  isIgnoreProcessLogin: boolean = false
) {
  return (dispatch: any) => {
    dispatch(updateLoginReducerState({ isLogin: false, isLoginXmpp: false }));
    // Get chat server time when user login
    return authService
      .loginRHP(
        {
          UserName: userName,
          Password: password,
        },
        rememberMe,
        buildVersion,
        agent,
        identifier,
        reCAPTCHAToken
      )
      .then(res => {
        if (res.success) {
          if (!isNative && userName) {
            // update lasted logged username
            storageHelper.setKey(constants.SESSIONS.LASTED_LOGGED_USER_NAME, res.data?.UserName?.toLowerCase());
          }
          if (!isIgnoreProcessLogin) {
            return processLogin(dispatch, userName, sessionJIdResourceMobile, buildVersion, shouldUseLocalData).then(res => {
              return res;
            });
          }
          return res;
        }
        console.log('ERROR: loginAction/loginRHP', res.message);
        return res;
      })
      .catch(e => {
        console.log('ERROR : loginAction/login/authService.loginRHP', e);
        //throw new Error('fail');
      });
  };
}

// todo login for product
export function loginWeb({
  Username,
  Password,
  SrcType = SRC_TYPES.APP,
  Latitude,
  Longitude,
}: {
  Username: string;
  Password: string;
  SrcType?: TSrcType;
  Latitude?: string;
  Longitude?: string;
}) {
  return (dispatch: any) => {
    return authService
      .loginRHPWeb({ Username, Password, SrcType, Latitude, Longitude })
      .then(res => {
        if (res.success) {
          if (!isNative && Username) {
            // update lasted logged username
            storageHelper.setKey(constants.SESSIONS.LASTED_LOGGED_USER_NAME, Username?.toLowerCase());
          }
          return res;
        }
        dispatch(loginFail(true, res.message));
        return res;
      })
      .catch(e => {
        console.log('ERROR : loginAction/login/authService.login', e);
        // throw new Error('fail');
      });
  };
}

export function logout() {
  return (dispatch: any) => {
    console.log('Goto logout');

    if (!WebIM.conn.isClosed() && !WebIM.conn.isClosing()) {
      WebIM.conn.close('logout');
    }
    // if (isNative) {
    return authService.logOut().then(res => {
      if (isNative) {
        dispatch(logoutSuccess());
      }
      config.rhpToken = '';
      config.token = '';
      config.rhpRefreshToken = '';

      return res;
    });
    // }
  };
}

export function register(userName: string, password: string) {
  return (dispatch: any) => {
    const register = { userName, password };
    dispatch(requestRegister(register));
    return userService.register(register, () => {
      dispatch(registerSuccess());
    });
  };
}

export function connectFacebook(params: IParamSignInWithFacebook, buildVersion?: string) {
  return (dispatch: any) => {
    return authService.signInWithFacebook(params).then(res => {
      if (res.success) {
        const userName = res.data.UserName;
        //  console.log('Login FB AUTH', userName);
        return processLogin(dispatch, userName, '', buildVersion, false);
      }
      console.log('ERROR: loginAction/loginFACEBOOK', res.message);
      // dispatch(loginFail(true, res.message));
      return res;
    });
  };
}

export function signInApple(params: any, buildVersion?: string, onlyProcess: boolean = false, response: IApiResponse | null = null) {
  return (dispatch: any) => {
    if (onlyProcess && response) {
      const result = response;
      if (response.data && response.data.BearerToken && response.data.BearerToken.length > 0) {
        if (storageHelper.storageCachingSupported()) {
          storageHelper.setKey(constants.SESSIONS.RHP_TOKEN, response.data.BearerToken);
        }
        config.rhpToken = response.data.BearerToken;
      }
      if (response.data && response.data.RefreshToken && response.data.RefreshToken.length > 0) {
        if (storageHelper.storageCachingSupported()) {
          storageHelper.setKey(constants.SESSIONS.RHP_REFRESH_TOKEN, response.data.RefreshToken);
        }
        config.rhpRefreshToken = response.data.RefreshToken;
      }
      if (result.success && result.data) {
        const userName = result.data.UserName;
        return processLogin(dispatch, userName, '', buildVersion, false);
      }
      console.log('ERROR: loginAction/loginAPPLE', result.message);
      // dispatch(loginFail(true, res.message));
      return result;
    }
    return authService.signInApple(params).then((res: any) => {
      const result = res;
      if (result.success && result.data) {
        const userName = result.data.UserName;
        return processLogin(dispatch, userName, '', buildVersion, false);
      }
      console.log('ERROR: loginAction/loginAPPLE', result.message);
      // dispatch(loginFail(true, res.message));
      return result;
    });
  };
}

export function signInGoogle({ idToken }: { idToken: string }, buildVersion?: string) {
  return (dispatch: any) => {
    return authService.signInGoogle({ idToken }).then(res => {
      if (res.success) {
        const userName = res.data.UserName;
        return processLogin(dispatch, userName, '', buildVersion, false);
      }
      console.log('ERROR: loginAction/loginGOOGLE', res.message);
      // dispatch(loginFail(true, res.message));
      return res;
    });
  };
}

export function updateStatusLoginFb(params: boolean) {
  return (dispatch: any) => {
    dispatch(updateStatusLoginFbSuccess(params));
  };
}

export function requestForgotPassword(data: boolean) {
  return (dispatch: any) => {
    dispatch(requestForgotPasswordSuccess(data));
  };
}

export function getAnonymousToken() {
  return () => {
    return authService.getAnonymousAccessToken().then(res => {
      // console.log(res);
    });
  };
}

export function updateRetainStatus(params: any) {
  return (dispatch: any) => {
    return authService.updateRetainStatus(params).then((res: any) => {
      if (res.success) {
        dispatch(updateRetainStatusSuccess(params));
      }

      return res;
    });
  };
}

export function getCreditCard() {
  return (dispatch: any) => {
    return authService.getCreditCard().then((res: any) => {
      if (res.success) {
        const userInfo = {
          creditCardInfo: res.data,
        };
        dispatch(updateUserInfo(userInfo));
      }
      return res;
    });
  };
}

export function deleteCreditCard() {
  return (dispatch: any) => {
    return authService.deleteCreditCard().then((res: any) => {
      if (res.success) {
        const userInfo: any = {
          creditCardInfo: null,
        };

        dispatch(updateUserInfo(userInfo));
      }
      return res;
    });
  };
}

export function updateCreditCard(params: any) {
  return (dispatch: any) => {
    return authService.updateCreditCard(params).then((res: any) => {
      if (res.success) {
        const userInfo = {
          creditCardInfo: res.data,
        };

        dispatch(updateUserInfo(userInfo));
      }
      return res;
    });
  };
}

// export function refreshTokenRHP(){
//     return dispatch => {
//         return
//     }
// }
export function updateUserSummaryTigase(userId: string | number, params: any) {
  return (dispatch: any) => {
    // console.log(userId, params)
    return userService.updateUserSummaryTigase(userId.toString(), params).then((res: any) => {
      return res;
    });
  };
}

export function customXmppAuthLogin(xmppAuthLogin: any) {
  return (dispatch: any) => {
    return authService.login(xmppAuthLogin).then((res: any) => {
      if (res && res.success && res.data) {
        dispatch(updateUserInfo(res.data.user));
      }
      return res;
    });
  };
}

// Mapping UserLogin Data
function mappingUserInfo(user: any): Partial<IUserInfo> {
  const userInfo: Partial<IUserInfo> = {};
  if (user) {
    userInfo.userId = user.userId;
    userInfo.displayName = user.displayName;
    userInfo.memberType = user.memberType;
    userInfo.old = user.old;
    userInfo.ageTitle = user.ageTitle;
    userInfo.location = user.location;
    userInfo.memberLevel = user.memberLevel;
    userInfo.memberLevelExpiry = user.memberLevelExpiry;
    userInfo.locationInfo = user.locationInfo;
    userInfo.detailInfo = user.detailInfo;
    userInfo.tempInfo = user.tempInfo;
    userInfo.isCouple = user.isCouple;
    userInfo.memberTypeTitle = user.memberTypeTitle;
    userInfo.verificationState = user.verificationState;
    userInfo.emailAddress = user.emailAddress;
    userInfo.usernameRejected = user.usernameRejected;
    userInfo.recurringStatus = user.recurringStatus;
    userInfo.activeProducts = user.activeProducts;
    userInfo.memberLevelValue = user.memberLevelValue;
    userInfo.isViewable = true;
  }
  return userInfo;
}

function mappingUserAvatar(user: Partial<IMainPhoto>): Partial<IUserInfo> {
  const userInfo: Partial<IUserInfo> = {};
  if (user) {
    userInfo.avatarUrl = user.thumbUrl || '';
    userInfo.avatarFullUrl = user.fullUrl || '';
    userInfo.isUserImage = user.isUserImage;
    userInfo.isPublic = user.isPublic;
    userInfo.imageType = user.imageType;
    userInfo.mainPhotoRestricted = !!user.classification && user.classification > 1 && user.imageType !== constants.NO_PHOTO;
  }
  return userInfo;
}

export function mappingUserSetting(user: any): Partial<IUserInfo> {
  let userInfo: Partial<IUserInfo> = {};
  if (user) {
    userInfo = {
      ...userInfo,
      isLoadedUserInfo: true,
      accountPaused: user.AccountSettings.AccountPaused,
      accountStatus: user.AccountSettings.AccountStatus || constants.ACCOUNT_STATUS.ACTIVE,
      accountDeleteDate: user.AccountSettings.AccountDeletedDate || '',
      safeMode: user.Client.SafeMode,
      isSpotlightFeatureEnabled: user.Client.IsSpotlightFeaturedEnabled,
      fileUploadLimit: user.Client.FileUploadLimit ? parseInt(user.Client.FileUploadLimit) * 1000000 : 20000000, // MB
      // isImageReplyEnabled: true,
      isImageReplyEnabled: !!(user.Client && user.Client.IsImageReplyEnabled),
      // isIgnoreConversationEnabled: false,
      isIgnoreConversationEnabled: !!(user.Client && user.Client.IsIgnoreConversationEnabled),
      // tooltips: user.ToolTips,
      country: MemberProfile.mappingMemberCountry(user.Profile.Country),
      messenger: {
        isLoading: false,
        isActive: user.Messenger.IsActive,
        permissionMessageReceive: user.Messenger.PermissionMessageReceive,
        permissionVideoCall: user.Messenger.PermissionVideoCall,
        replyLimitDays: user.Messenger.ReplyLimitDays,
        defaultFolder: user.Messenger.DefaultFolder,
        defaultImageDuration: ImageDuration.getImageDurationFromEnum(user.Messenger.DefaultImageDuration),
        canReceivePhotos: user.Messenger.CanReceivePhotos,
        canReceiveGifts: user.Messenger.CanReceiveGifts,

        // TODO: should map from API
        theme: MessengerTheme.mappingObject(user.Messenger.Theme),
      },
      chatroomSettings: {
        isActive: user.ChatroomSettings.IsActive,
        permissionMessageReceive: user.ChatroomSettings.PermissionMessageReceive,
        isSoundEnabled: user.ChatroomSettings.IsSoundEnabled,
      },
      toolTips: ToolTipSetting.mappingObjects(user.ToolTips),
      accountRequiresAuthentication: user.AccountSettings.AccountRequiresAuthentication || false,
      newPasswordRequired: user.AccountSettings.NewPasswordRequired || false,
      profileBoostExpiry: user.AccountSettings.ProfileBoostExpiry,
      streamSettings: StreamSettings.mappingObject(user.StreamSettings),
      // streamSettings: StreamSettings.mappingObject({ ActivityFilters: ['Events', 'Forums', 'Validations'] }),
    };
    if (user.Client && user.Client.Grants) {
      userInfo = {
        ...userInfo,
        client: {
          userVideoSizeLimit: user.Client.UserVideoSizeLimit,
          isVideoMessageEnabled: user.Client.IsVideoMessageEnabled,
          mobileValidationNumber: user.Client.MobileValidationNumber ? `+${formatSpaceNumber(user.Client.MobileValidationNumber)}` : '',
          communityVideoSizeLimit: user.Client.CommunityVideoSizeLimit,
          userVideoUploadMaxRetries: user.Client.UserVideoUploadMaxRetries,
          userVideoUploadPollInterval: user.Client.UserVideoUploadPollInterval,
          isUserPhotoCommentsEnabled: user.Client.IsUserPhotoCommentsEnabled,
          isScreenShotEnabled: user.Client.IsScreenShotEnabled || false,
        },
        grants: {
          event: {
            canCreateEvent: user.Client.Grants && user.Client.Grants.Event ? user.Client.Grants.Event.CanCreateEvent : false,
            canViewContacts: user.Client.Grants && user.Client.Grants.Event ? user.Client.Grants.Event.CanViewContacts : false,
          },
          message: {
            auVisaRequired: user.Client.Grants && user.Client.Grants.Message ? user.Client.Grants.Message.AUVisaRequired : false,
            showReplyLimit: user.Client.Grants && user.Client.Grants.Message ? user.Client.Grants.Message.ShowReplyLimit : false,
            canMakeVideoCalls: user.Client.Grants && user.Client.Grants.Message ? !!user.Client.Grants.Message.CanMakeVideoCalls : false,
          },
          photo: {
            uploadRequired: user.Client.Grants && user.Client.Grants.Photo ? user.Client.Grants.Photo.UploadRequired : false,
          },
          profile: {
            canViewPhoneNumbers: user.Client.Grants && user.Client.Grants.Profile ? user.Client.Grants.Profile.CanViewPhoneNumbers : false,
            canUseAnonymousBrowsing:
              user.Client.Grants && user.Client.Grants.Profile ? user.Client.Grants.Profile.CanUseAnonymousBrowsing : false,
          },
          prospects: {
            canRemoveFav: user.Client.Grants && user.Client.Grants.Prospects ? user.Client.Grants.Prospects.CanRemoveFav : false,
            canRemoveLike: user.Client.Grants && user.Client.Grants.Prospects ? user.Client.Grants.Prospects.CanRemoveLike : false,
            canViewLikes: user.Client.Grants && user.Client.Grants.Prospects ? user.Client.Grants.Prospects.CanViewLikes : false,
            canViewMatches: user.Client.Grants && user.Client.Grants.Prospects ? user.Client.Grants.Prospects.CanViewMatches : false,
          },
          community: {
            articleCanComment: true,
            eventCanComment: true,
            forumCanComment: true,
            storyCanComment: true,
          },
          group: {
            canManageGroups: user.Client.Grants && user.Client.Grants.Group ? user.Client.Grants.Group.CanManageGroups : false,
          },
        },
      };
      if (user.Client.Grants.Community) {
        userInfo.grants!.community.forumCanComment = user.Client.Grants.Community.ForumCanComment;
        userInfo.grants!.community.articleCanComment = user.Client.Grants.Community.ArticleCanComment;
        userInfo.grants!.community.storyCanComment = user.Client.Grants.Community.StoryCanComment;
        userInfo.grants!.community.eventCanComment = user.Client.Grants.Community.EventCanComment;
      }
    }
    if (user.PushSettings && user.PushSettings.NotificationSettings) {
      const notificationSettings = PushNotificationSettings.mappingObject(user.PushSettings.NotificationSettings);
      userInfo = {
        ...userInfo,
        notificationSettings: {
          ...notificationSettings,
          isEnabled: user.PushSettings.IsEnabled,
        },
      };
    }
    if (user.AccountSettings && user.AccountSettings.EmailNotificationSettings) {
      const emailNotificationSettings = EmailNotificationSettings.mappingObject(user.AccountSettings.EmailNotificationSettings);
      userInfo = {
        ...userInfo,
        emailNotificationSettings,
      };
    }

    if (user.AccountSettings) {
      const accountSetting = AccountSettingsProfile.mappingObject(user.AccountSettings);
      userInfo = {
        ...userInfo,
        accountSettings: accountSetting,
      };
    }

    if (user.LinkedAccounts) {
      const linkedAccounts = LinkedAccounts.mappingObject(user.LinkedAccounts);
      userInfo = {
        ...userInfo,
        linkedAccounts,
      };
    }
  }
  return userInfo;
}

export function patchPushNotificationSettings(params: any) {
  return (dispatch: any) => {
    return notificationSettingsService.patchNotificationSettings(params).then(res => {
      if (res && res.success) {
        dispatch(
          requestLoginUserInfoSuccess({
            userInfo: {
              notificationSettings: {
                ...res.data,
              },
            },
          })
        );
      }
      return res;
    });
  };
}

export function patchEmailNotificationSettings(params: any) {
  return (dispatch: any) => {
    return notificationSettingsService.patchEmailSettings(params).then(res => {
      if (res && res.success) {
        dispatch(
          requestLoginUserInfoSuccess({
            userInfo: {
              emailNotificationSettings: {
                ...res.data,
              },
            },
          })
        );
      }
      return res;
    });
  };
}

export function patchUpdateAccountSetting(params: any) {
  return (dispatch: any) => {
    return userService.patchUpdateAccountSetting(params).then(res => {
      if (res && res.success) {
        dispatch(
          requestLoginUserInfoSuccess({
            userInfo: {
              accountSettings: {
                ...res.data,
              },
            },
          })
        );
      }
      return res;
    });
  };
}

export function postPauseAccount() {
  return (dispatch: any) => {
    return accountSettingService.postPauseAccount().then(res => {
      if (res && res.success) {
        dispatch(
          requestLoginUserInfoSuccess({
            userInfo: {
              accountPaused: true,
            },
          })
        );
      }
      return res;
    });
  };
}

export function postUnPauseAccount() {
  return (dispatch: any) => {
    return accountSettingService.postUnPauseAccount().then(res => {
      if (res && res.success) {
        dispatch(
          requestLoginUserInfoSuccess({
            userInfo: {
              accountPaused: false,
            },
          })
        );
      }
      return res;
    });
  };
}
